import InvoiceReportEditConfigController from './InvoiceReportEditConfigController'

export default class InvoiceEditResultConfigController extends InvoiceReportEditConfigController {}

InvoiceEditResultConfigController.prototype.makeReportParamsAccordingToFeatures = function(reportParameters) {
    return reportParameters
}


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/InvoiceEditResultConfigController.js